import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Forma y de dónde salen los valores: docs/Paquete_Arranque_Frontend.md §2.
// NO se necesita `appId` — Auth y Firestore se inicializan sin él, y la
// Firebase Web App no existe (solo la requeriría Analytics).
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

// 🚨 El idioma de los correos de Identity Platform Y de la pantalla que abre
// su enlace.
//
// El SDK manda este valor como cabecera `X-Firebase-Locale`, y es lo que fija
// el `lang` del enlace. NO basta con `notification.defaultLocale` del
// proyecto: medido el 2026-09-21 con `defaultLocale: "es"` ya puesto, el
// enlace salía con `lang=en` y el manejador se veía en inglés aunque el correo
// llegara en español.
//
// Fijo, no `useDeviceLanguage()`: el público es colombiano y un navegador en
// inglés no significa que la persona quiera el correo en inglés. El día que
// haya clientes en otro idioma, esto sale del tenant.
auth.languageCode = 'es';
// Mapa en vivo (FE-03, ADR-008): mismo SDK y mismos tokens que la auth,
// sin librerías nuevas. Solo lectura — las security rules de
// infra/firestore/firestore.rules niegan cualquier escritura del cliente.
export const db = getFirestore(firebaseApp);

// Decisión laxa: persistencia local (estándar en SPAs). El backend puede
// revocar la sesión del lado servidor cuando haga falta invalidarla antes
// de que expire el token (~1h) — docs/Paquete_Arranque_Frontend.md §4.
void setPersistence(auth, browserLocalPersistence);
